import { render } from "./file_drop_overlay.vue?vue&type=template&id=98d0c498&scoped=true&lang=pug"
import script from "./file_drop_overlay.vue?vue&type=script&setup=true&lang=js"
export * from "./file_drop_overlay.vue?vue&type=script&setup=true&lang=js"

import "./file_drop_overlay.vue?vue&type=style&index=0&id=98d0c498&lang=scss&scoped=true"

import exportComponent from "../../../../../node/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-98d0c498"]])

export default __exports__